<div [ngClass]="baseService.isMobile ? 'd-flex flex-column gap-2 align-items-start' : 'd-flex align-items-center'">
  <app-search (onValueChange)="onSearchChange($event)"></app-search>

  @if (selectionTable.selected.length) {
    <div>
      <app-button #t="matMenuTrigger" [matMenuTriggerFor]="menu">
        <div class="d-flex w-100 align-items-center justify-content-between">
          <span class="selected_dropdown">({{ selectionTable.selected.length }}) {{ 'selected' | translate }}</span>
          <app-icon class="align-middle selected_dropdown">
            {{ t.menuOpen ? 'expand_less' : 'expand_more' }}
          </app-icon>
        </div>
      </app-button>
      <mat-menu #menu="matMenu" yPosition="below" xPosition="before" class="p-0">
        @for (item of bulkActionList; track item; let i = $index) {
          <button mat-menu-item (click)="bulkActionPopup(item)">
            {{ item.label | translate }}
          </button>
        }
      </mat-menu>
    </div>
  }

  @if (!baseService.isMobile) {
    <div class="flex-fill"></div>
  }

  @if (balance) {
    <div [ngClass]="{ 'm-0': baseService.isMobile }" class="d-flex flex-column text-black fs-sm me-4">
      <div>{{ 'your_account_information' | translate }}: {{ balance?.sum }} {{ 'UAH' | translate }}.</div>
      <div>{{ 'available_balance' | translate }}: {{ balance?.bonus }} {{ 'bonuses' | translate }}</div>
    </div>
  }

  <app-dropdown
    class="account-box"
    [ngClass]="{ 'w-100': baseService.isMobile }"
    [items]="items || []"
    [input]="currentChannelId || {}"
    [bindValue]="'id'"
    (onValueChange)="onValueChange($event)"
    [closeOnSelect]="true"
    [searchable]="true"
    placeholder="{{ 'channels' | translate }}"
  ></app-dropdown>
</div>

@if (filterStatuses?.length) {
  <div class="mt-2 d-flex gap-2 flex-wrap" [ngClass]="{ 'justify-content-center': baseService.isMobile }">
    @for (item of filterStatuses; track item) {
      <h5 class="text-black">
        <div
          class="badge btn-static click-css"
          [ngStyle]="{ '--color': item.active ? item.color : '#cccccc' }"
          (click)="onFilterChange('status', item)"
        >
          {{ item.name | translate }}
        </div>
      </h5>
    }
  </div>
}

@if (isLoader) {
  <div class="d-flex justify-content-center">
    <app-loader size="small"></app-loader>
  </div>
} @else {
  @if (dataSource$ | async; as dataSource) {
    <app-table
      class="w-100"
      [dataSource]="dataSource"
      [visibleColumnKeys]="visibleColumns"
      (onSortChange)="onSortChange($event)"
      (onPaginationChange)="onPaginationChange($event)"
      (menuSelected)="onActionChange($event)"
      (onTableRowClick)="onRowClick($event.row)"
      [showUpPagination]="true"
      [selection]="selectionTable"
    ></app-table>
  }
}
